import Container from './Container';
import Panel from './Panel';

export default Object.assign({ Container }, { Panel });
